import { gql, useQuery } from '@apollo/client';
import {
  GetRoleQuery,
  GetRoleQueryVariables,
} from '../../../__generated__/queries-auth';

export const GET_ROLE = gql`
  query GetRole($where: RoleUniqueFilterInput!) {
    role(where: $where) {
      id
      slug
    }
  }
`;

export const useGetRole = (id?: string, skip?: boolean) =>
  useQuery<GetRoleQuery, GetRoleQueryVariables>(GET_ROLE, {
    variables: { where: { id } },
    skip: !id || skip,
  });
